import { getLocalStorage, setLocalStorage } from './localStorage';

const IPAPI_URL = 'https://ipapi.co/json/';
const STORAGE_KEY = 'ipapi_location';

/**
 * Returns cached location { country, city, region } from localStorage, or null.
 * @returns {{ country: string, city: string, region: string } | null}
 */
export const getLocationForAuth = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = getLocalStorage(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data && typeof data.country === 'string' && typeof data.city === 'string' && typeof data.region === 'string') {
      return { country: data.country, city: data.city, region: data.region };
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Fetches location from ipapi.co, saves only country/city/region to localStorage.
 * Skips fetch if data already cached. Call once on main page load.
 * @returns {Promise<{ country: string, city: string, region: string } | null>}
 */
export const fetchAndCacheLocation = async () => {
  if (typeof window === 'undefined') return null;
  try {
    const existing = getLocalStorage(STORAGE_KEY);
    if (existing) return getLocationForAuth();

    const res = await fetch(IPAPI_URL, { method: 'GET' });
    if (!res.ok) return null;

    const data = await res.json();
    const location = {
      country: data.country_name ?? data.country ?? '',
      city: data.city ?? '',
      region: data.region ?? data.region_code ?? '',
    };
    setLocalStorage(STORAGE_KEY, JSON.stringify(location));
    return location;
  } catch (err) {
    console.warn('ipapi.co fetch failed:', err?.message);
    return null;
  }
};
